import React, { Component } from "react";
import { mdiCalendarText } from "@mdi/js";
import Icon from "@mdi/react";

import styles from "./styles.scss";
import PlayerImage from "../PlayerImage";
import NewsDetail from "../../News/NewsDetail";
import PlayerInjuryStatusItem from "../PlayerInjuryStatusItem";
// import { Team } from "src/common-services";
import { PlayerCardButton } from "src/components/PlayerCard/PlayerCardButton";
import { PlayerCardName } from "src/components/PlayerCard/PlayerCardName";

interface PlayerLineupItemProps {
  team: any;
  playerLineup: any;
  showDepthPosition?: boolean;
}

interface PlayerLineupItemState {
  newsExpanded: boolean;
  showDepthPosition: boolean;
}

/**
 * Player lineup line item - mobile ready.
 * This displays the headshot of the player, their position, and if there is any news about the player as well as if
 * the player has an injury flag associated with them.  If there is news an icon is provided and the user can
 * expand or collapse their news beneath the line item of the player
 */
export default class PlayerLineupItem extends Component<PlayerLineupItemProps, PlayerLineupItemState> {
  constructor(props: PlayerLineupItemProps) {
    super(props);
    this.state = {
      newsExpanded: false,
      showDepthPosition: props.showDepthPosition === true,
    };
  }

  render() {
    const { playerLineup } = this.props;
    const { newsExpanded } = this.state;
    const displayPosition = playerLineup.position;
    let { player } = playerLineup;
    if (!player) {
      player = {
        depthOrder: "",
        fullName: "Unknown",
        imageUrl: "",
        injuryStatus: "",
        news: "",
      };
    }

    return (
      <div>
        <div className="rotoql-player-lineup__info-container">
          <PlayerCardButton className="rotoql-player-lineup__card-button" player={player}>
            <div className="rotoql-player-lineup__position">{displayPosition} </div>
            <PlayerImage url={player.imageUrl} containerClassName="rotoql-player-lineup__image-container" />
            <PlayerCardName className="rotoql-player-lineup__player-name">{player.fullName}</PlayerCardName>
          </PlayerCardButton>
          <div>
            <PlayerInjuryStatusItem injuryStatus={player.injuryStatus} />
          </div>
          {player.news ? (
            <React.Fragment>
              <Icon path={mdiCalendarText} size="16px" color="#004198" />
              {/* If the screen is large enough add the text "Latest News" next to the icon */}
              <div
                className="rotoql-player-lineup__latest-news"
                onClick={() => {
                  this.setState({ newsExpanded: !newsExpanded });
                }}
              >
                Latest News
              </div>
            </React.Fragment>
          ) : null}
        </div>
        {player.news && newsExpanded ? (
          <div className="rotoql-player-lineup__news-container">
            <NewsDetail news={player.news} expanded={newsExpanded} />
          </div>
        ) : null}
        <style jsx global>
          {styles}
        </style>
      </div>
    );
  }
}
